<template>
  <div>
    <q-header id="nav" unelevated style="z-index: 2">
      <q-toolbar class="top-navigation">
        <!-- Handle Desktop Drawer Opening -->
        <div v-if="$q.screen.gt.sm && this.miniState === true">
          <q-btn
            flat
            dense
            round
            @click="miniState = false"
            aria-label="Menu"
            icon="menu"
          />
        </div>
        <div v-if="$q.screen.gt.sm && this.miniState === false">
          <q-btn
            flat
            dense
            round
            @click="miniState = true"
            aria-label="Menu"
            icon="menu_open"
          />
        </div>
        <!-- Handle Mobile Drawer Opening -->
        <div v-if="$q.screen.lt.md">
          <q-btn
            dense
            round
            unelevated
            flat
            icon="menu"
            @click="drawer = !drawer"
          />
        </div>

        <q-toolbar-title class="text-capitalize">
          Client Portal /

          <!-- (Single Game Only) If Parent > Child -->
          <div
            style="display: inline"
            v-if="
              this.$route.query.name ||
              (this.$route.params.name &&
                !this.$route.meta.parent &&
                !this.$route.params.category)
            "
          >
            Games Library /
            <span class="text-weight-bold">{{
              formatNewsCategory(this.$route.query.name)
            }}</span>
          </div>

          <!-- (Excluding Latest News) If Parent -->
          <span
            class="text-weight-bold"
            v-if="
              !this.$route.query.name &&
              !this.$route.params.name &&
              !this.$route.meta.parent &&
              !this.$route.params.category
            "
            >{{ this.$route.name }}</span
          >

          <!-- (Excluding Latest News) If Parent > Child  -->
          <div
            style="display: inline"
            v-if="
              !this.$route.query.name &&
              !this.$route.params.category &&
              this.$route.meta.parent &&
              this.$route.meta.breadcrumbDisabled === false
            "
          >
            {{ this.$route.meta.parent }} /
            <span class="text-weight-bold">{{ this.$route.name }} </span>
          </div>
          <!-- (Latest News) If Parent only -->
          <span
            class="text-weight-bold"
            v-if="
              !this.$route.query.name &&
              this.$route.params.name &&
              !this.$route.meta.parent &&
              !this.$route.params.category
            "
            >{{ formatNewsCategory(this.$route.params.name) }}</span
          >

          <!-- (Latest News) if Parent > Child -->
          <div
            style="display: inline"
            v-if="
              !this.$route.query.name &&
              this.$route.params.name &&
              !this.$route.meta.parent &&
              this.$route.params.category
            "
          >
            {{ this.$route.params.categoryName }} /
            <span class="text-weight-bold">{{
              this.$route.params.formattedName
            }}</span>
          </div>
        </q-toolbar-title>
        <q-btn
          rounded
          unelevated
          :label="username"
          no-caps
          class="top-navigation__user"
          icon="face"
          aria-label="Profile"
          exact
        />
        <q-btn
          flat
          dense
          round
          @click="signOut"
          aria-label="Sign Out"
          icon="logout"
        />
      </q-toolbar>
      <Notifications v-if="this.$store.state.siteNotification" />
    </q-header>
    <q-drawer
      id="sidenav"
      class="left-navigation"
      side="left"
      show-if-above
      v-model="drawer"
      :width="320"
      :breakpoint="1024"
      @mouseover="miniState = false"
      :mini="!drawer || miniState"
      @click.capture="drawerClick"
    >
      <q-scroll-area class="fit">
        <q-list>
          <q-item class="left-navigation__logo">
            <span
              v-if="this.darkMode === true"
              class="left-navigation__logo--dark logo"
              @click="logoClickHandler()"
            />
            <span
              v-else
              class="left-navigation__logo--light logo"
              @click="logoClickHandler()"
            />
          </q-item>

          <div
            v-for="route in routes"
            :key="route.path"
            class="left-navigation__link"
          >
            <q-item
              v-if="!route.children && !route.meta.hiddenInNav"
              :to="route"
              exact
              clickable
              v-ripple
              class="left-navigation__item"
            >
              <template v-slot:default>
                <q-item-section avatar class="left-navigation__item--icon">
                  <q-icon :name="route.meta.icon" />
                </q-item-section>
                <q-item-section class="left-navigation__item--label"
                  ><q-item-label>{{ route.name }}</q-item-label></q-item-section
                >
              </template>
            </q-item>
            <q-expansion-item
              v-if="route.children && route.children.length > 0"
              group="route"
              header-class="left-navigation__item-expansion"
              :class="{
                'expansion--active ': childPathActive(route.path),
              }"
            >
              <template v-slot:header>
                <q-item-section
                  avatar
                  class="left-navigation__item-expansion--icon"
                >
                  <q-icon :name="route.meta.icon" />
                </q-item-section>
                <q-item-section class="left-navigation__item-expansion--label">
                  <q-item-label>{{ route.name }}</q-item-label>
                </q-item-section>
              </template>
              <div v-for="(child, index) in route.children" :key="index">
                <q-item
                  v-if="!child.meta.hiddenInNav"
                  :to="child.path"
                  exact
                  clickable
                  v-ripple
                  style="
                    border-bottom: 1px solid #ddd;
                    min-height: unset;
                    font-size: 12px;
                    padding-left: 72px;
                    background-color: #fff;
                  "
                >
                  {{ child.name }}
                  <!-- <q-item-section
                    class="left-navigation__item-expansion__sub-item--label"
                    style="margin-left: 12px; border: 1px solid red"
                    ><q-item-label>{{
                      child.name
                    }}</q-item-label></q-item-section
                  > -->
                </q-item>
              </div>
            </q-expansion-item>
          </div>
          <q-item
            tag="label"
            v-ripple
            class="left-navigation__item left-navigation__item--helper"
            @click="darkMode = !darkMode"
          >
            <q-item-section avatar>
              <q-icon :name="darkMode === false ? 'light_mode' : 'dark_mode'" />
            </q-item-section>
            <q-item-section>
              <q-item-label
                >Toggle Theme -
                <span class="text-capitalize">{{ themeStatus }}</span>
                Mode</q-item-label
              >
            </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
      <div class="drawer-close-mobile absolute" style="top: 15px; right: -17px">
        <q-btn
          dense
          round
          unelevated
          color="secondary"
          icon="menu_open"
          @click="drawer = !drawer"
        />
      </div>
    </q-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Notifications from "@/components/global/Notifications.vue";
import { formatNewsCategory } from "@/utils/formatText";
export default {
  name: "TheSiteNavigation",
  props: {
    routes: Array,
  },
  data() {
    return {
      drawer: true,
      miniState: true,
      darkMode: false,
      themeStatus: "light",
      // routes: [],
    };
  },
  components: {
    Notifications,
  },

  methods: {
    formatNewsCategory,
    drawerClick(event) {
      // if in "mini" state switch it to "normal" mode
      if (this.miniState) {
        this.miniState = false;
        // we need to stop further propagation as this click is intended for switching drawer to "normal" mode only
        event.stopPropagation();
      }
    },
    signOut() {
      this.$store.dispatch("logout");
    },
    childPathActive(input) {
      // Work around for child path active to show parent acitve
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    logoClickHandler() {
      this.$router.push({ name: "Home" });
    },
  },
  watch: {
    darkMode: function (mode) {
      if (mode === false) {
        this.$q.dark.set(false);
        this.themeStatus = "light";
      } else {
        this.$q.dark.set(true);
        this.themeStatus = "dark";
      }
    },
  },
  computed: {
    ...mapState(["username"]),
  },
};
</script>

<style lang="scss">
.q-item__section--avatar {
  min-width: unset;
}
.q-item.q-router-link--active,
.q-item--active {
  background-color: #f5f5f5;
  color: unset;
  font-weight: bold;
  color: #ed7237 !important;
}
.q-drawer--mini {
  .left-navigation__logo {
    &--dark {
      background-image: url("~@/assets/logo-small.png"); //smaller logo
    }
    &--light {
      background-image: url("~@/assets/logo-small.png"); //smaller logo
    }
    .logo {
      height: 30px;
      width: 30px;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      top: 15px;
      left: 15px;
      display: block;
    }
  }
}
.q-drawer--mobile {
  .left-navigation__logo {
    &--dark {
      background-image: url("~@/assets/logo-dark.svg"); //should be dark
    }
    &--light {
      background-image: url("~@/assets/logo-light.svg");
    }
    .logo {
      height: 30px;
      width: 125px;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      top: 15px;
      left: 14px;
      display: block;
    }
  }
}
.q-drawer--standard {
  cursor: pointer;
  .left-navigation__logo {
    &--dark {
      background-image: url("~@/assets/logo-dark.svg"); //dark
    }
    &--light {
      background-image: url("~@/assets/logo-light.svg");
    }
    .logo {
      height: 40px;
      width: 200px;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      top: 8px;
      left: 60px;
      display: block;
    }
  }
}
.drawer-close-mobile {
  display: block;
  @media only screen and (min-width: 1019px) {
    display: none;
  }
}
</style>
